module.exports = __webpack_public_path__ + "static/eu-df36610463889ce4a615322bb83972ca.png";